import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AudienceModule } from './audience/audience.module';
import { MassMessagingModule } from './mass-messaging/mass-messaging.module';
import { OptinsModule } from './optins/optins.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, MassMessagingModule, AudienceModule, OptinsModule],
})
export class MarketingModule {}
